/**
 * Frontend error reporter - sends uncaught errors to the backend error monitoring service.
 */

const API_URL = process.env.REACT_APP_BACKEND_URL;

export function initErrorReporter() {
  // Catch unhandled promise rejections
  window.addEventListener('unhandledrejection', (event) => {
    const msg = event.reason?.message || String(event.reason);
    const noise = [
      'this.o.at is not a function', 'Java object is gone',
      'Failed to update a ServiceWorker', 'posthog',
      'enableDidUserTypeOnKeyboardLogging'
    ];
    if (noise.some(n => msg.includes(n))) return;

    reportError({
      message: msg,
      stack: event.reason?.stack || '',
      url: window.location.pathname,
      component: 'UnhandledPromise'
    });
  });

  // Catch global errors
  window.addEventListener('error', (event) => {
    // Ignore browser-internal errors that are NOT real app bugs
    const msg = event.message || '';
    const noise = [
      'ResizeObserver', 'Script error.', '_AutofillCallbackHandler',
      'webkit.messageHandlers', 'posthog', 'this.o.at is not a function',
      'Java object is gone', 'Failed to update a ServiceWorker',
      'enableDidUserTypeOnKeyboardLogging'
    ];
    if (noise.some(n => msg.includes(n))) return;

    reportError({
      message: event.message,
      stack: event.error?.stack || '',
      url: window.location.pathname,
      component: event.filename || 'Global'
    });
  });
}

export async function reportError(errorData) {
  try {
    const token = localStorage.getItem('token');
    const headers = { 'Content-Type': 'application/json' };
    if (token) headers['Authorization'] = `Bearer ${token}`;

    await fetch(`${API_URL}/api/errors/report`, {
      method: 'POST',
      headers,
      body: JSON.stringify({
        message: errorData.message?.substring(0, 500),
        stack: errorData.stack?.substring(0, 2000),
        url: errorData.url || window.location.pathname,
        component: errorData.component || '',
        user_agent: navigator.userAgent
      })
    });
  } catch (e) {
    // Silently fail - don't cause more errors from error reporting
  }
}
